import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=405edf7a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('405edf7a')) {
      api.createRecord('405edf7a', component.options)
    } else {
      api.reload('405edf7a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=405edf7a&", function () {
      api.rerender('405edf7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nsx3mkVPnagG/JS/comp/FavElement.vue"
export default component.exports